import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { messageActions } from "../../../../_actions";
import { useParams, useHistory, useLocation } from "react-router-dom";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import TextButton from "../../../v2/common/TextButton";
import ConversationItem from "./Utilities/ConversationItem";
import MessageDetailsLoader from "./Utilities/MessageDetailsLoader";
import { requestOrigin } from "_constants";

export default function MessageDetails() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const messages = useSelector((state) => state.messages?.message);
  const messagesLoading = useSelector((state) => state.messages?.loading);
  const params = useParams();
  const { id } = params;

  const handleBackButton = () => {
    const searchParams = new URLSearchParams(location?.search || "");
    const returnTo = searchParams.get("returnTo");

    if (returnTo) {
      const decoded = decodeURIComponent(returnTo);
      if (decoded.startsWith("/")) {
        history.push(decoded);
        return;
      }
    }

    history.goBack();
  };

  useEffect(() => {
    const _params = { addedDetails: true };
    dispatch(
      messageActions.getDetailsFromTrends(
        id,
        _params,
        requestOrigin.ANALYZE,
        true,
      ),
    );
  }, [dispatch, params]);

  return (
    <Box sx={styles.rootWrapper}>
      <Box sx={styles.container}>
        <TextButton
          label={"Back"}
          action={handleBackButton}
          sx={styles.backButton}
          rootStyle={styles.backButtonRoot}
          startIcon={<ChevronLeftOutlinedIcon sx={styles.backButtonIcon} />}
        />

        {messagesLoading && <MessageDetailsLoader />}

        {!messagesLoading && messages && (
          <Box sx={styles.card}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #CED4D4",
                padding: "20px",
                marginBottom: "20px",
              }}
            >
              <Box
                sx={{
                  fontFamily: "LarsseitMedium",
                  fontSize: "18px",
                  fontWeight: 500,
                  color: "#0C2728",
                }}
              >
                {messages?.channel}
              </Box>
              <Box>
                <a
                  className="viewInSourceLink"
                  target="_blank"
                  rel="noreferrer noopener nofollow"
                  href={messages?.link}
                >
                  View in{" "}
                  {messages?.sourceName
                    ? messages?.sourceName
                    : "source platform"}
                </a>
              </Box>
            </Box>

            {messages?.conversation?.map((conversation) => {
              return (
                <Fragment key={conversation.id}>
                  <ConversationItem conversation={conversation} />
                </Fragment>
              );
            })}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export const styles = {
  rootWrapper: {
    backgroundColor: "#EDEDE4",
    pt: 16,
    pb: 10,
    minHeight: "100vh",
  },
  container: {
    px: { xs: 2, sm: 6 },
    maxWidth: "1440px",
  },
  card: {
    width: "100%",
    maxWidth: "1024px",
    background: "#FFFFFF",
    borderRadius: "8px",
    border: "1px solid #dee2e0",
    boxShadow: "0 2px 4px 0 rgba(196, 201, 199, 0.5)",
    marginTop: "20px",
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    height: "10px",
  },
  backButtonIcon: {
    mr: "-5px",
  },
  backButtonRoot: {
    fontSize: "14px",
    height: "20px",
    color: "#0C2728",
    textAlign: "left",
    fontFamily: "LarsseitMedium",
    ":hover": {
      color: "#081a1a",
      backgroundColor: "unset",
    },
    ":disabled": {
      color: "#8c8f8f",
    },
    ":active": {
      outline: "0",
      color: "#0C2728",
    },
  },
};
